(function ($) {
  $.fn.selectpicker.defaults = {
    noneSelectedText: 'Vyberte ze seznamu',
    noneResultsText: 'Pro hledání {0} nebyly nalezeny žádné výsledky',
    countSelectedText: 'Vybrané {0} z {1}',
    maxOptionsText: ['Limit překročen ({n} {var} max)', 'Limit skupiny překročen ({n} {var} max)', ['položek', 'položka']],
    multipleSeparator: ', ',
    selectAllText: 'Vybrat vše',
    deselectAllText: 'Zrušit výběr'
  };
})(jQuery);
